// hooks/useImpersonateUser.js

import { useAuthenticationStore } from "../../../stores/auth";
import { useApiClient } from "../../../api";

export const useImpersonateUser = () => {
  const ApiClient = useApiClient();

  const { startImpersonation, updateUserInfo } = useAuthenticationStore();

  const impersonateUser = async (targetUser) => {
    try {
      const response = await ApiClient.users.impersonateUser({
        targetUser: targetUser.id,
      });

      if (!response.success) {
        throw new Error(response.message || "Failed to impersonate user");
      }

      const { token, refreshToken, refreshExpiresIn } = response;

      const originalSession = {
        ...useAuthenticationStore.getState().user,
      };

      startImpersonation(
        {
          info: originalSession.info,
          token,
          refreshToken,
          refreshExpiresIn,
        },
        originalSession,
      );

      await ApiClient.client.clearStore();

      const userData = await ApiClient.users.me();

      updateUserInfo(userData);

      return {
        success: true,
      };
    } catch (error) {
      console.error("Failed to impersonate user", error);

      return {
        success: false,
        error,
      };
    }
  };

  return {
    impersonateUser,
  };
};
